import { render, staticRenderFns } from "./TaskPFollowUpDialog.vue?vue&type=template&id=903ec906"
import script from "./TaskPFollowUpDialog.vue?vue&type=script&lang=ts"
export * from "./TaskPFollowUpDialog.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports